import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { merge } from 'lodash-es';
import { initReactI18next } from 'react-i18next';

import { resources as udacityApplicationResources } from '@udacity/application/i18n';
import { resources as udacityAssessmentResources } from '@udacity/assessment/i18n';
import { resources as udacityCertificateResources } from '@udacity/udacity-certificate/i18n';
import { resources as udacityHeaderResources } from '@udacity/udacity-header-v2/i18n';
import auth from '@udacity/ureact-hoth';

import { NEXT_LOCALE_COOKIE } from '~/features/cookies/constants';

import enUS from './locales/en-US.json';
import { languages } from './languages';

type LngResource = { translation?: Record<string, unknown> };

const enUSCert = (udacityCertificateResources as Record<string, LngResource>)['en-US']?.translation;
const enUSHeader = (udacityHeaderResources as Record<string, LngResource>)['en-US']?.translation;
const enUSApp = (udacityApplicationResources as Record<string, LngResource>)['en-US']?.translation;
const enUSAssessment = (udacityAssessmentResources as Record<string, LngResource>)['en-US']?.translation;

const initialResources = {
  [languages.enUS.id]: {
    translation: merge({}, enUS, enUSCert, enUSHeader, enUSApp, enUSAssessment),
  },
};

const i18n = createInstance({
  resources: initialResources,
  fallbackLng: languages.enUS.id,
  debug: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: true },
  returnEmptyString: false,
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      // Authenticated users may have a manual preference that should win before
      // preferences load. Anonymous users should prefer live browser language so
      // stale locale cookies do not override their current browser settings.
      // `localStorage` stays as the final fallback (matching the previous order)
      // so a cached locale is not lost when neither cookie nor navigator resolves.
      order: auth.isAuthenticated() ? ['cookie', 'navigator', 'localStorage'] : ['navigator', 'cookie', 'localStorage'],
      lookupCookie: NEXT_LOCALE_COOKIE,
    },
  });

export { i18n };
